import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileDate',
  standalone: true,
})
export class MobileDatePipe implements PipeTransform {
  public transform(
    value: string[] | undefined | null
  ): string | string[] | undefined | null {
    if (
      value === undefined ||
      value === null ||
      value.length < 2 ||
      !value[0] ||
      !value[1]
    ) {
      return value;
    }
    const start = new Date(value[0]);
    const end = new Date(value[1]);

    let sameMonth = true;

    if (start.getMonth() !== end.getMonth()) {
      sameMonth = false;
    }

    const startDate = start.toLocaleDateString('en', {
      month: 'short',
      day: 'numeric',
    });
    const endDate = sameMonth
      ? end.toLocaleDateString('en', { day: 'numeric' })
      : end.toLocaleDateString('en', { month: 'short', day: 'numeric' });

    return `${startDate} - ${endDate}`;
  }
}
